import CryptoJS from "crypto-js";
import {secretKey} from "./constants";

export const getSettings = async () => {
    const isDevelopment = process.env.NODE_ENV === "development";
    let encryptedSettingsObject = sessionStorage.getItem("settingsObject")
    if (isDevelopment) {
        // Always refresh local settings in development so baseUrl edits apply immediately.
        const settingsFileAddress = `/settings/settings.local.json?t=${Date.now()}`;
        const settingsResponse = await fetch(settingsFileAddress, { cache: "no-store" });
        return await settingsResponse.json();
    }

    if (encryptedSettingsObject == null) {
        let baseUrl = "";
        const settingsFileAddress = baseUrl + "/settings/settings.json"
        const settingsResponse = await fetch(settingsFileAddress)
        let settingsObject = await settingsResponse.json()

        encryptedSettingsObject = CryptoJS.AES.encrypt(
            JSON.stringify(settingsObject),
            secretKey
          ).toString();
          
        sessionStorage.setItem("settingsObject", encryptedSettingsObject);  
        return settingsObject;  
    }

    const bytes = CryptoJS.AES.decrypt(encryptedSettingsObject, secretKey);
    const decryptedSettingsObject = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    return decryptedSettingsObject;
}
